import React from 'react';
import Footer from '../components/Footer';
import '../App.css';

export default function Education() {
  return (
    <>
      <h1 className='education'>Education</h1>
      <div className='filler'>
        <p>Computer Science at Unicamp (Campinas/SP, 2016 - 2021).</p>
      </div>
      <Footer />
    </>
  );
}